import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { UPDATE_USER_MUTATION } from '../graphql/mutations/updateUser';
import { GET_USERS } from '../graphql/queries/getUsers';

export interface UpdateUser {
  email: string;
  enabled?: boolean;
  portfolioCodes: string[];
  accounts: { id: string }[];
  portal: boolean;
  permissions: {
    pledging: boolean;
    pledgeAndRelease: boolean;
    apm: boolean;
    files: boolean;
    cds: boolean;
    muniCredit: boolean;
    houstonTrust: boolean;
  };
}

export const useUpdateUser = () => {
  const [updateUserMutation, { data, loading, error }] = useMutation(UPDATE_USER_MUTATION, {
    refetchQueries: [{ query: GET_USERS }]
  });

  const updateUser = async (
    { email, enabled, portal, portfolioCodes, accounts, permissions }: UpdateUser,
    toastMessage?: string
  ) => {
    const variables = {
      userUpdateDto: {
        email,
        enabled,
        portal,
        portfolioCodes,
        accounts,
        permissions
      }
    };

    try {
      await updateUserMutation({ variables });
      toast.success(toastMessage || 'User updated successfully!');
    } catch (err) {
      toast.error('There was an error updating the user.');
    }
  };

  return { updateUser, data, loading, error };
};
